import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroImage } from '../data/copy';
const badges = ['Immediate Access', 'Secure Payment', '7-Day Guarantee'];
export function Hero() {
  return <header className="w-full bg-blush" data-id="element-79" data-mp="9ih0dmtnseqi">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-6 text-center sm:pb-12 sm:pt-8" data-id="element-80" data-mp="4mrul1r1q1lr">
        <Pill data-id="element-81" data-mp="129qurmgy5roe">Ballet Teacher Elite System</Pill>

        <h1 className="mx-auto mt-5 max-w-2xl font-display text-[2rem] leading-[1.08] text-charcoal sm:text-[2.75rem] lg:text-5xl" data-id="element-82" data-mp="127efjh2kpvf1">
          Stop Planning From Scratch.
          <span className="mt-1 block text-wine" data-id="element-83" data-mp="s9zybf8tt2lo">
            Solve an Entire Year of Ballet Classes in Minutes.
          </span>
        </h1>

        <div className="mx-auto mt-5 max-w-md rounded-3xl border border-rose-deep/25 bg-cream/70 p-3 shadow-soft sm:max-w-lg sm:p-4" data-id="element-84" data-mp="nekl8pin7aqb">
          <img src={heroImage} alt="The complete Ballet Teacher Elite System: six master volumes, seven bonus books and printable planners." className="mx-auto w-full rounded-2xl" width={1240} height={1240} data-id="element-85" data-mp="3825ywscu0bmf" />
        </div>

        <p className="mx-auto mt-5 max-w-xl font-sans text-sm leading-relaxed text-ash sm:text-base" data-id="element-86" data-mp="3o6arg04e8f22">
          <span className="font-medium text-wine" data-id="element-87" data-mp="399tej4gk2sde">
            6 Master Volumes + 7 Strategic Bonuses
          </span>{' '}
          — the complete ready-to-teach library for ages 3 to 16.
        </p>

        <div className="mt-5" data-id="element-88" data-mp="30ggelik2qqht">
          <CtaButton size="large" data-id="element-89" data-mp="30g6l3kztm17d">Get the Elite System </CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-90" data-mp="35a2jgojzxq32">
          {badges.map(badge => <li key={badge} className="flex items-center gap-2 font-sans text-xs font-medium tracking-wide text-ash" data-id="element-91" data-mp="2qi0l58xkr555">
              <CheckCircle2Icon className="h-4 w-4 text-gold" strokeWidth={1.6} aria-hidden="true" data-id="element-92" data-mp="2hjf6hov84a9n" />
              {badge}
            </li>)}
        </ul>
      </div>
    </header>;
}